// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner-card[data-v-574de2b4]{width:100%}@media (min-width:992px){.banner-card[data-v-574de2b4]{height:470px;margin-bottom:-360px}}", ""]);
// Exports
module.exports = exports;
